compiler('.shipping_packaging_select', (element) => {
    element.addEventListener('change', function() {
      save_changed_value(this);
    });

  function save_changed_value(element) {
    var value = element.value;
    var packaging_type = null;
    if (element.value == "0") {
      packaging_type = "custom";
      value = ""
    } else if (element.value == "-1") {
      packaging_type = "standard";
      value = ""
    }

    fetch('/delivery_trackings/' + element.dataset.deliveryTrackingId, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('input[name="authenticity_token"]').value
      },
      body: JSON.stringify({ shipping_packaging_id: value, shipping_packaging_type: packaging_type })
    }).then(function(response) {
      if (response.ok) {
        window.location.reload();
      } else {
        console.log('Error');
      }
    });
  }
});
